import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var searchResultsUrl = '/busca';
var SearchService = /** @class */ (function () {
    function SearchService(router) {
        this.router = router;
        /**
         * CSCSATIVA-5524] - DESENVOLVIMENTO - AJUSTE NAVEGAÇÃO TECLADO RESULTADO PESQUISA CAIXA PESQUISA
         */
        this.selectedTabindexSearchBar$ = new BehaviorSubject(null);
    }
    SearchService.prototype.searchFor = function (searchTerm) {
        var url = this.router.url;
        this.router.navigate([this.getCurrentLanguageFromURL(url) + searchResultsUrl, { 'searchTerm': searchTerm }]);
    };
    SearchService.prototype.getCurrentLanguageFromURL = function (url) {
        var terms = url.split('/');
        var isSpanish = terms.indexOf('es');
        var isEnglish = terms.indexOf('us');
        if (isSpanish > 0)
            return '/' + terms[isSpanish];
        if (isEnglish > 0)
            return '/' + terms[isEnglish];
        return '/br';
    };
    /**
     * CSCSATIVA-5524] - DESENVOLVIMENTO - AJUSTE NAVEGAÇÃO TECLADO RESULTADO PESQUISA CAIXA PESQUISA
     */
    SearchService.prototype.getSearchbarTabindex = function () {
        return this.selectedTabindexSearchBar$.asObservable();
    };
    SearchService.prototype.setSearchbarTabindex = function (tabindexSearchBar) {
        this.selectedTabindexSearchBar$.next(tabindexSearchBar);
    };
    SearchService.ngInjectableDef = i0.defineInjectable({ factory: function SearchService_Factory() { return new SearchService(i0.inject(i1.Router)); }, token: SearchService, providedIn: "root" });
    return SearchService;
}());
export { SearchService };
